import React from 'react';
import {Button} from '@shopify/polaris';
import {useNavigate} from "react-router-dom";

const LocalMenu = () => {
    const navigate = useNavigate();
    return (
        <div className="header-menu-admin">
            <Button size="large" onClick={() => {
                navigate('/')
            }}>App Configuration</Button>
            <Button size="large" onClick={() => {
                navigate('/contact-support')
            }}>Contact Support</Button>
            <Button size="large" onClick={() => {
                navigate('/faq')
            }}>FAQ</Button>
        </div>
    );
};

export default LocalMenu;
